import { render, staticRenderFns } from "./VeJwBkXueshengModal.vue?vue&type=template&id=2a872ca6"
import script from "./VeJwBkXueshengModal.vue?vue&type=script&lang=js"
export * from "./VeJwBkXueshengModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports